import Vue from 'vue';
import 'dotenv/config';
// axios
import axios from 'axios';
import Swal from 'sweetalert2';

let baseURL = process.env.VUE_APP_HOST_API_BACKEND_PROD;
if (process.env.VUE_APP_MODE_APP !== 'production' && process.env.VUE_APP_HOST_API_BACKEND_DEV) {
  baseURL = process.env.VUE_APP_HOST_API_BACKEND_DEV;
}

const axiosIns = axios.create({
  baseURL,
});

axiosIns.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosIns.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      await Swal.fire({
        icon: 'warning',
        title: 'Sessão expirada',
        text: 'Seu token de acesso expirou. Por favor, faça login novamente.',
        confirmButtonText: 'Ok',
      });
    }

    return Promise.reject(error);
  },
);

// async handlerCancelarPedido() {
//   Swal.fire({
//     title: 'Cancelar Pedido',
//     text: 'Deseja realmente cancelar o pedido?',
//     icon: 'warning',
//     showCancelButton: true,
//     confirmButtonText: 'Sim',
//     cancelButtonText: 'Não',
//     confirmButtonColor: '#d33',
//     cancelButtonColor: '#3085d6',
//   }).then((result) => {
//     if (result.isConfirmed) {
//       this.$store.dispatch('PedidosStore/clearPedidoAndItemPedido')
//       this.$router.push({ name: 'home' })
//     }
//   })
// }

// axiosIns.interceptors.response.use(
//     response => response,
//     error => {
//         if (error.response.status === 401) {
//             localStorage.removeItem('userData')
//             localStorage.removeItem('accessToken')
//             localStorage.removeItem('refreshToken')
//             // window.location.href = '/login'
//         }
//         return Promise.reject(error)
//     }
// )

Vue.prototype.$http = axiosIns;

export default axiosIns;
